import { API_URL } from "../config/connect";

const request = async (path, { method = "GET", body } = {}) => {
    const token = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const d = data.detail;
        const message =
            (typeof d === "string" && d) ||
            (Array.isArray(d) && d.map((x) => `${(x.loc || []).slice(1).join(".")}: ${x.msg}`).join("; ")) ||
            `HTTP ${response.status}`;
        const error = new Error(response.status === 403 ? "Недостаточно прав." : message);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

// kind: "countries" | "regions" | "districts"
const LIST_KEY = { countries: "countries", regions: "regions", districts: "districts" };

export const listLocations = (kind, params = {}) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== "")).toString();
    return request(`/api/v1/admin/${kind}${qs ? `?${qs}` : ""}`).then((d) => d[LIST_KEY[kind]] || []);
};
export const createLocation = (kind, body) => request(`/api/v1/admin/${kind}`, { method: "POST", body });
export const updateLocation = (kind, id, body) => request(`/api/v1/admin/${kind}/${id}`, { method: "PATCH", body });
export const deleteLocation = (kind, id) => request(`/api/v1/admin/${kind}/${id}`, { method: "DELETE" });
